export const COOKIE_PAGE_SIZE = 'pageSize';
